export const aciHamburger = {
    iconName: 'hamburger',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                d: 'M2 18.309h20M2 12.152h20M2 6h20',
                stroke: 'currentColor',
                'stroke-width': '1.215',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
